/**
 * Whether the Wallet can start a top-up (MYP-134).
 *
 * The vendor's `molpay_pay` exists (guide of 2026-10-26), but there is no sandbox: its gateway
 * goes to the live Fiuu merchant, so the first real top-up is a real payment. **Off** until one
 * RM 10 top-up has gone through end to end with the mentor's OK.
 *
 * While it is off the Top up card can be filled in (amount, quick amounts, summary), but Pay does
 * not call the vendor: it says FPX top-up is not switched on yet and links to mypoz.com, where
 * top-up works today. The result page does **not** depend on it: the vendor always sends the
 * customer back to web.mypoz.com, so that page must work before this is turned on. Turning it on
 * is this one line.
 */
export const FIUU_TOPUP_ENABLED = false;

/**
 * The FPX fee shown on the Top up card, in cents. RM 0: the old mypoz.com top-up page charges
 * nothing for online banking (only cards carry a fee). Shown, not worked out, so a fee the vendor
 * later confirms is a change here alone.
 */
export const FIUU_FPX_FEE_CENTS = 0;

/**
 * Where the Top up card keeps the record id (`accdetailid`) of the top-up it last sent the
 * customer to pay, so the result page can fall back on it if the address loses it. sessionStorage:
 * per tab, and only a convenience — the result page asks `get_trade` how it stands, never this.
 */
export const LAST_TOP_UP_KEY = 'mypoz.topUp.lastAccDetailId';
